import { Vehicle } from 'api3';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { TabService } from '@app/services/tab.service';
import { DisplayVehicle } from '@app/services/types';
import { VehicleService } from '@app/services/vehicle.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-vehicle-details-sidebar',
  imports: [CommonModule, TranslocoPipe, NgOptimizedImage],
  standalone: true,
  templateUrl: './vehicle-details-sidebar.component.html',
  preserveWhitespaces: false,
})
export class VehicleDetailsSidebarComponent {
  tabService = inject(TabService);
  vehicleService = inject(VehicleService);

  vehicle = computed<DisplayVehicle | undefined>(() => {
    const activeTab = this.tabService.activeTab();
    if (!activeTab?.session?.vehicle) {
      return undefined;
    }
    return {
      ...activeTab?.session?.vehicle,
      vehicleIdentification: activeTab?.vehicleIdentification,
    } as DisplayVehicle;
  });

  vehicleImageUrl = computed(() => {
    if (!this.vehicle()) {
      return undefined;
    }
    return this.vehicleService.getVehicleImage(this.vehicle() as Vehicle);
  });

  fuelTypesString = signal<string | undefined>(undefined);

  onVehicleChange = effect(async () => {
    const fuelsString = await this.vehicleService.getFuelsString(this.vehicle()?.fuelType);
    this.fuelTypesString.set(fuelsString);
  });
}
